import { ControlCellModel } from "model/ControlCell.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = ControlCellModel[];

export const useDefaultObservableControlCellModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectControlCellModelArray extends BehaviorSubject<CurrentType> {}
